import React from "react";
import { useIntl } from "react-intl";
// import TagFilter from "Modules/.common/components/TagFilter";

const TagsFilter = ({ id, values, onChange }) => {
  const { messages } = useIntl();
  return (
    <>  </>
    // <TagFilter
    //   id={id}
    //   label={messages["vehicleView_tags"]}
    //   placeholder={messages["vehicleView_tags"]}
    //   values={values}
    //   multiple={true}
    //   onChange={onChange}
    //   showUntagged={true}
    //   inline={true}
    //   maxHeight="308px"
    //   entity="Unit"
    // />
  );
};

export default TagsFilter;
